import { render, staticRenderFns } from "./LiquidationOfHours.vue?vue&type=template&id=2471afc2&scoped=true"
import script from "./LiquidationOfHours.vue?vue&type=script&lang=js"
export * from "./LiquidationOfHours.vue?vue&type=script&lang=js"
import style0 from "./LiquidationOfHours.vue?vue&type=style&index=0&id=2471afc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2471afc2",
  null
  
)

export default component.exports